import { AppRegistry } from 'react-native';
import App from './App';

const appName = 'lighting-controls-mobile'; // app.json'daki "name" alanı ile aynı olmalı!

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
